import { HumanResourceService } from './../../services/human-resource.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import {
  NgbDate,
  NgbDateStruct,
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators, FormGroup, FormArray } from '@angular/forms';
import { AppPattern } from 'src/app/services/app-pattern';
import * as moment from 'moment';
import { DiaryReportService } from 'src/app/services/diary-report.service';
import { MasterDataCommon } from 'src/app/master-data/master-data.common';
@Component({
  selector: 'app-diary-details',
  templateUrl: './diary-details.component.html',
  styleUrls: ['./diary-details.component.css'],
})
export class DiaryDetailsComponent implements OnInit {
  page = 1;
  pageSize = 10;
  pageLength = 0;
  showRow = false;
  diaryForm;
  modalForm;
  reports;
  showReports = false;
  employeeList;
  empType = 'Active';
  typeList = [
    { id: 1, name: 'Active' },
    { id: 0, name: 'Closed' },
  ];
  formSubmitted = false;
  formErrors = MasterDataCommon.diaryDetailsFormErrors;
  formValidationMessages = MasterDataCommon.diaryDetailsFormValidationMessages;
  empFName;
  empLName;
  fdate;
  tdate;
  // activeEmp = [];
  // closedEmp = [];
  // typeEmpList = [];
  config: any;
  collection = { count: 60, reports: [] };
  totalDebitHr;
  totalDebitMin;
  totalDebitHrMin;
  totalCreditHr;
  totalCreditMin;
  totalNoOfHr;
  totalNoOfMin;
  totalAmount;
  sumOfDebitedHours;
  sumOfCreditedHours;
  sumOfNumberOfHours;

  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder,
    private humanResourceService: HumanResourceService,
    private diaryReportService: DiaryReportService
  ) {
    this.config = {
      itemsPerPage: 10,
      currentPage: 1,
      totalItems: this.reports,
    };
  }

  pageChanged(event) {
    if (this.pageLength == event) {
      this.showRow = true;
    } else {
      this.showRow = false;
    }
  }

  ngOnInit(): void {
    this.loadEmployeeProfiles();
    this.initDiaryForm();
  }

  // loadProfiles() {
  //   this.humanResourceService.getProfiles().subscribe((res: any) => {
  //     this.employeeFormList = res;
  //     for (let i = 1; i < this.employeeFormList.length; i++) {
  //       if (this.employeeFormList[i].userOfficialDetails == null || this.employeeFormList[i].userOfficialDetails.profileStatus == 1) {
  //         this.activeEmp.push(this.employeeFormList[i]);
  //       } else {
  //         this.closedEmp.push(this.employeeFormList[i]);
  //       }
  //     }
  //     this.typeEmpList = this.activeEmp;
  //   });
  // }

  // onSelectEmp() {
  //   if (this.diaryForm.value.empStatus != 'Active') {
  //     this.typeEmpList = this.closedEmp;
  //   }else{
  //     this.typeEmpList = this.activeEmp;
  //   }
  // }

  loadEmployeeProfiles(){
    console.log('empType',this.empType);
    var changeEmpType;
    if(this.empType=='Active'){
      changeEmpType=1;
    }else{
      changeEmpType=0;
    }
    this.humanResourceService.getEmployeeProfile(changeEmpType).subscribe((res: any) => {
      this.employeeList = res;
      console.log('employee list',this.employeeList);
  });
}

  initDiaryForm() {
    this.diaryForm = this.fb.group({
      empStatus: ['', [Validators.required, Validators.maxLength(50)]],
      employee: ['', [Validators.required, Validators.maxLength(50)]],
      fromDate: ['', [Validators.required]],
      toDate: ['', [Validators.required]],
    });
  }

  onViewReport() {
    this.showRow = false;
    this.formSubmitted = true;

    this.logValidationErrors(this.diaryForm);

    if (this.diaryForm.valid) {
      this.page = 1;
      console.log('inside view report Method');
      this.fdate =
        this.diaryForm.value.fromDate.year +
        '-' +
        this.diaryForm.value.fromDate.month +
        '-' +
        this.diaryForm.value.fromDate.day;
      this.tdate =
        this.diaryForm.value.toDate.year +
        '-' +
        this.diaryForm.value.toDate.month +
        '-' +
        this.diaryForm.value.toDate.day;

      this.empFName = this.diaryForm.value.employee.firstName;
      this.empLName = this.diaryForm.value.employee.lastName;
      this.reports = [];
      this.diaryReportService.getDiaryDetailsReport(this.diaryForm).subscribe(
        (resp) => {
          this.reports = resp;
          this.showReports = true;
          console.log('After view report response', this.reports, this.showReports);
          this.pageLength = Math.ceil(this.reports.length / 10);
          if (this.pageLength == 1) {
            this.showRow = true;
          } else {
            this.showRow = false;
          }
          this.fndTotalCount(this.reports);
        },
        (error) => {
          console.log(error);
        }
      );
    }
  }

  logValidationErrors(group: FormGroup): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid && this.formSubmitted) {
          const messages = this.formValidationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }

  fndTotalCount(report) {
    this.totalDebitHr = 0;
    this.totalDebitMin = 0;
    this.totalDebitHrMin = 0;
    this.totalCreditHr = 0;
    this.totalCreditMin = 0;
    this.totalNoOfHr = 0;
    this.totalNoOfMin = 0;
    this.totalAmount = 0;

    for (let i = 0; i < report.length; i++) {
      this.totalDebitHr += report[i].debitHrs;
      this.totalDebitMin += report[i].debitMin/60;

      this.totalCreditHr += report[i].creditHrs;
      this.totalCreditMin += report[i].creditMin/60;

      this.totalNoOfHr += report[i].noOfHoursHr;
      this.totalNoOfMin += report[i].noOfHoursMin/60;

      this.totalAmount += report[i].amount;
    }
    this.sumOfDebitedHours=this.totalDebitHr+this.totalDebitMin;
    this.sumOfDebitedHours=this.convertToHoursAndMinutes(this.sumOfDebitedHours);
    this.sumOfCreditedHours=this.totalCreditHr+this.totalCreditMin;
    this.sumOfCreditedHours=this.convertToHoursAndMinutes(this.sumOfCreditedHours);
    this.sumOfNumberOfHours=this.totalNoOfHr+this.totalNoOfMin;
    this.sumOfNumberOfHours=this.convertToHoursAndMinutes(this.sumOfNumberOfHours);
    // this.totalDebitMin=this.totalDebitMin>=60?this.totalDebitMin/60:this.totalDebitMin;
    // this.totalCreditMin=this.totalCreditMin>=60?this.totalCreditMin/60:this.totalCreditMin;
    // this.totalNoOfMin=this.totalNoOfMin>=60?this.totalNoOfMin/60:this.totalNoOfMin;
    console.log('reportlength', report.length);

  }

  convertToHoursAndMinutes(floatNum: number) {
    const hours = Math.floor(floatNum);
    const minutes = Math.round((floatNum - hours) * 60);
    var temp = String(hours)+"."+String(minutes); 
    return temp;
  }

  exportToExcelClick(){
    this.diaryReportService.getDiaryDetailsReportForExportToExcel(this.diaryForm).subscribe(
      (resp:any) => {
        const blob = new Blob([resp]); // you can change the type
        var downloadURL= window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "DiaryReport.xlsx";
        link.click();
      });
  }
}
